import React, { useState, FormEvent, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { GoogleLoginButton } from "../Google/GoogleLoginButton";
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { SystemContext } from "../../Theme";

export const Login: React.FC = () => {
  const [showTimeoutBanner, setShowTimeoutBanner] = useState(false);
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { systemName } = React.useContext(SystemContext);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
  };
  useEffect(() => {
    // Parse the query parameters from the URL
    const params = new URLSearchParams(location.search);
    if (params.get('timeout') === 'true') {
      setShowTimeoutBanner(true);
    }
  }, [location]);

  return (
    <div>
      {/* Session Timeout Banner */}
      {showTimeoutBanner && (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      backgroundColor: "#ffcc00",
                      color: "#000",
                      padding: "10px",
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <Typography>
                      Your session has expired. Please log in again.
                    </Typography>
                  </Box>
                </Grid>
              )}
    <Grid container justifyContent="center" alignItems="center" height="100vh">
      <Grid item xs>
        <Container maxWidth="xs" fixed>
          <Paper elevation={24}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              direction="column"
              rowSpacing={2}
              padding={2}
            >
              <Grid item>
                <Typography>👋 Welcome back to {systemName}!</Typography>
              </Grid>
              <Grid item>
                <Typography>Your Personalized AI Chatbot Assistant!</Typography>
              </Grid>
              <Grid item>
                <Typography>
                  <Link
                    component={RouterLink}
                    style={{ color: "purple", fontWeight: "bold" }}
                    to='https://drive.google.com/file/d/1hMvdefRu6klXP_noVHN2LtawRtHv6oJm/view'
                    target='_blank'
                  >
                    User Guide
                  </Link>{" "}
                  here
                </Typography>
              </Grid>
              {!process.env.REACT_APP_DISABLE_PASSWORD_LOGIN && (
                <Grid
                  item
                  container
                  justifyContent="center"
                  alignItems="center"
                  columnSpacing={1}
                >
                  <Box component="form" onSubmit={handleSubmit}>
                    <TextField
                      id="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      label="Email"
                      fullWidth
                      helperText="Please enter your email."
                    />
                    <TextField
                      id="password"
                      name="password"
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      label="Password"
                      fullWidth
                      helperText="Please enter your password."
                    />
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      value="Login"
                    >
                      Login
                    </Button>
                  </Box>
                  {/* {message && <div className="error-message">{message}</div>} */}
                </Grid>
              )}
              <Grid item marginBottom={2}>
                <GoogleLoginButton mode="login"/>
              </Grid>
            </Grid>
          </Paper>
        </Container>
      </Grid>
    </Grid>
    </div>
  );
};
